import { render } from "./boardMain.vue?vue&type=template&id=13ece865&scoped=true"
import script from "./boardMain.vue?vue&type=script&lang=js"
export * from "./boardMain.vue?vue&type=script&lang=js"

import "./boardMain.vue?vue&type=style&index=0&id=13ece865&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13ece865"]])

export default __exports__